var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import * as authDrawerConstants from "../constants/authDrawer";
import * as appConstants from "../config/constants";
import backend from "./backend";
import * as actionTypes from "../constants/actionTypes";
import { setLocalItem, getLocalItem, removeLocalItem } from "./localdb";

export var eventFilter = function eventFilter(event, expectedSource) {
  try {
    return event && event.origin === window.location.origin && event.isTrusted && event.source && "name" in event.source && event.source.name === expectedSource && event.data && "authToken" in event.data && event.data.authToken;
  } catch (e) {
    return false;
  }
};

// Refresh token by opening up invisible iFrame
export var refreshToken = function refreshToken() {
  // The token will be refreshed, so there's no reason to keep it anymore.
  removeLocalItem("authToken");

  var framePromise = new Promise(function (resolve) {
    var iframe = document.createElement("iframe");

    iframe.src = authDrawerConstants.AUTH_URL;
    iframe.width = 0;
    iframe.height = 0;
    iframe.style.border = "none";
    iframe.name = "reauthorization iframe";

    document.body.appendChild(iframe);

    window.addEventListener("message", function (event) {
      if (eventFilter(event, iframe.name)) {
        resolve(event.data.authToken);
        iframe.remove();
      }
    });
  });

  var timeoutPromise = new Promise(function (resolve, reject) {
    var timeoutId = window.setTimeout(function () {
      window.clearTimeout(timeoutId);
      reject();
    }, 5000);
  });

  return Promise.race([framePromise, timeoutPromise]);
};

export var updateAxiosToken = function updateAxiosToken(token) {
  var authToken = void 0;

  if (token) {
    authToken = token;

    setLocalItem("authToken", authToken, { expires: 31 });
  } else {
    authToken = getLocalItem("authToken");
  }

  // Update Axios instance to send headers after auth
  backend.defaults.headers.common = _extends({}, backend.defaults.headers.common, {
    Authorization: "Bearer " + authToken
  });
};

export var checkAuthStatus = function checkAuthStatus() {
  return function (dispatch) {
    if (getLocalItem("authToken")) {
      return dispatch({
        type: actionTypes.LOGGED_IN_STATUS,
        payload: true
      });
    } else {
      dispatch({
        type: actionTypes.LOGGED_IN_STATUS,
        payload: false
      });
    }
  };
};

// Log out of the backend
export var backendLogOut = function backendLogOut() {
  var iframe = document.createElement("iframe");

  iframe.src = authDrawerConstants.LOGOUT_URL;
  iframe.width = 0;
  iframe.height = 0;
  iframe.style.border = "none";
  iframe.name = "logout iframe";

  document.body.appendChild(iframe);
};

export var setNonce = function setNonce() {
  if (!window) {
    return;
  }
  var socialNonce = void 0;

  if (window.crypto && window.crypto.getRandomValues) {
    socialNonce = window.crypto.getRandomValues(new Uint32Array(1))[0].toString();
  } else {
    socialNonce = (Math.random() * 1e10).toString(36);
  }

  setLocalItem("socialNonce", socialNonce);
};

var getNonce = function getNonce() {
  return getLocalItem("socialNonce");
};

var getAuthorizeUrl = function getAuthorizeUrl() {
  var nonce = getNonce();
  var socialRedirectUri = encodeURIComponent(appConstants.FRONTEND_ROOT + "/authorize?next=" + encodeURIComponent(appConstants.FRONTEND_ROOT));
  return appConstants.BACKEND_ROOT + "/o/authorize?client_id=" + authDrawerConstants.CLIENT_ID + "&redirect_uri=" + socialRedirectUri + "&scope=read%20write&response_type=token&state=" + nonce;
};

export var getFacebookUrl = function getFacebookUrl() {
  var authUrl = getAuthorizeUrl();
  return appConstants.BACKEND_ROOT + "/login/facebook/?next=" + encodeURIComponent(authUrl);
};

export var getLinkedInUrl = function getLinkedInUrl() {
  var authUrl = getAuthorizeUrl();
  return appConstants.BACKEND_ROOT + "/login/linkedin-oauth2/?next=" + encodeURIComponent(authUrl);
};


// WEBPACK FOOTER //
// ./src/utils/auth.js